import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import './headBanner.scss'

class headBanner extends React.Component {
  render() {
    // console.log(this.props.character)
    return <div>
        <div className='user-banner'>
          <img src={require('./images/banner.png')} alt={''} />
        </div>
        <div className="user-text">
          我们的调研分为“基本信息”和“机械通气雾化治疗技术”两个部分，请您根据顺序耐心填写，感谢您参与我们的调研。
          </div>
        <div className="user-content">
        <h5>{this.props.character.text}  <span> <strong>{this.props.character.one}</strong> {this.props.character.two}</span></h5>
        </div>
    </div>
  }
}

// headBanner.propTypes = {
//   text: PropTypes.array.isRequired
// }

export default headBanner


// WEBPACK FOOTER //
// ./src/components/head-banner/index.js